import { EQuantityFormatKey, IQuantityFormat } from '../../StoreSettings.types';

import {
  ABBREVIATION_BOOLEAN_OPTIONS,
  ABBREVIATION_SEPARATOR_OPTIONS
} from './AbbreviationsSettingsV2.consts';
import {
  EAbbreviationDropdownType,
  IAbbreviationDropdownField,
  IAbbreviationDropdownOption,
  QuantityFieldPath,
  QuantityFieldValue
} from './AbbreviationsSettingsV2.types';

export const getQuantityFieldPath = (
  sectionKey: EQuantityFormatKey,
  fieldKey: keyof IQuantityFormat
): QuantityFieldPath => `${sectionKey}.${fieldKey}`;

export const getAbbreviationDropdownOptions = (
  field: IAbbreviationDropdownField
): IAbbreviationDropdownOption[] =>
  field.type === EAbbreviationDropdownType.BOOLEAN
    ? ABBREVIATION_BOOLEAN_OPTIONS
    : ABBREVIATION_SEPARATOR_OPTIONS;

export const getAbbreviationDropdownSelectedValue = (
  field: IAbbreviationDropdownField,
  rawValue: QuantityFieldValue | undefined
): string =>
  field.type === EAbbreviationDropdownType.BOOLEAN
    ? String(Boolean(rawValue))
    : String(rawValue);

export const parseAbbreviationDropdownValue = (
  field: IAbbreviationDropdownField,
  value: string
): QuantityFieldValue =>
  field.type === EAbbreviationDropdownType.BOOLEAN ? value === 'true' : value;
